import {Types} from 'mongoose';
import {
    VALID_PERIOD_1_YEAR_ID,
    VALID_PERIOD_2_YEAR_ID,
    VALID_PERIOD_3_YEAR_ID,
    VOLUNTEER_ORIENTATION_STATUS_ATTENDED,
} from './valid-period.consts';

export const VALID_PERIOD = {
    type: 'Valid Period',
    category: 'System',
    value: [
        {_id: new Types.ObjectId(VALID_PERIOD_1_YEAR_ID), label: '1 Year'},
        {_id: new Types.ObjectId(VALID_PERIOD_2_YEAR_ID), label: '2 Year'},
        {_id: new Types.ObjectId(VALID_PERIOD_3_YEAR_ID), label: '3 Year'},
    ],
};

export const VOLUNTEER_ORIENTATION_STATUS = {
    type: 'Volunteer Orientation Status',
    category: 'System',
    value: [
        {
            _id: new Types.ObjectId(VOLUNTEER_ORIENTATION_STATUS_ATTENDED),
            label: 'Attended',
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799489087'),
            label: 'Not Attended',
        },
    ],
};
